<template>
  <section>
    <report-filter-bar
      v-model="filter"
      :preset="preset"
      :busy="isAnyLoading"
      :compare-label="compareLabel"
      @preset="applyPreset"
      @change="refresh"
      @refresh="refresh"
    />

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="acquisition"
          title="مشتری جدید در برابر بازگشتی"
          subtitle="«جدید» یعنی اولین خرید در کل تاریخچه، نه اولین خرید داخل این بازه"
          :metrics="['registered', 'new', 'returning']"
          type="bar"
          :height="320"
          :loading="loading('acquisition')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-chart
          :series="acquisition"
          title="درآمد از مشتری جدید و بازگشتی"
          :subtitle="rangeLabel"
          :metrics="['revenueNew', 'revenueReturning']"
          type="area"
          :height="300"
          :loading="loading('acquisition')"
          :skin="skin"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="6"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="rfm"
          title="سگمنت‌بندی RFM"
          subtitle="بر اساس تازگی، تعداد و مبلغ خرید — آستانه‌ها نسبی و مخصوص همین سایت است"
          label-title="سگمنت"
          :loading="loading('rfm')"
        />
      </b-col>

      <b-col
        lg="6"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="top"
          title="پرارزش‌ترین مشتری‌ها"
          :subtitle="rangeLabel"
          label-title="مشتری"
          :loading="loading('top')"
          :route-for="userRoute"
        />
      </b-col>
    </b-row>

    <!--
      کوهورت: هر سطر گروهی است که اولین خریدش در آن ماه بوده و ستون‌ها
      نشان می‌دهند چند درصدشان در ماه‌های بعد برگشته‌اند.
    -->
    <b-row>
      <b-col
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="cohort"
          title="نگهداشت کوهورتی"
          subtitle="درصد بازگشت هر گروه در ماه‌های بعد از اولین خرید"
          label-title="ماه اولین خرید"
          :show-share="false"
          :loading="loading('cohort')"
          empty-text="برای محاسبه‌ی کوهورت هنوز داده‌ی کافی وجود ندارد"
        />
      </b-col>
    </b-row>

    <b-row class="match-height">
      <b-col
        lg="5"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byState"
          title="پراکندگی استانی"
          subtitle="بر اساس استان ثبت‌شده در پروفایل کاربر"
          label-title="استان"
          :loading="loading('byState')"
        />
      </b-col>

      <b-col
        lg="3"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byGender"
          title="جنسیت"
          :subtitle="rangeLabel"
          label-title="جنسیت"
          :loading="loading('byGender')"
        />
      </b-col>

      <b-col
        lg="4"
        cols="12"
        class="mb-1"
      >
        <report-table
          :breakdown="byAge"
          title="گروه سنی"
          subtitle="فقط کاربرانی که تاریخ تولد ثبت کرده‌اند"
          label-title="گروه"
          :loading="loading('byAge')"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import reportMixin from '@core/mixins/report'

export default {
  name: 'ReportCustomers',
  mixins: [reportMixin],
  data() {
    return {
      acquisition: null,
      rfm: null,
      top: null,
      cohort: null,
      byState: null,
      byGender: null,
      byAge: null,
    }
  },
  computed: {
    compareLabel() {
      return this.acquisition && this.acquisition.CompareRange
        ? this.acquisition.CompareRange.Label
        : null
    },
  },
  created() {
    this.refresh()
  },
  methods: {
    refresh() {
      const api = this.$api.report

      this.fetchReport('acquisition', api.customerAcquisition)
      this.fetchReport('rfm', api.customerRfm)
      this.fetchReport('top', api.customerTop)
      this.fetchReport('cohort', api.customerCohort)

      // بُعد جمعیتی از کوئری‌استرینگ خوانده می‌شود، نه از بدنه
      this.fetchReport('byState', `${api.customerDemographics}?by=state`)
      this.fetchReport('byGender', `${api.customerDemographics}?by=gender`)
      this.fetchReport('byAge', `${api.customerDemographics}?by=age`)
    },

    userRoute(row) {
      return row.Id ? { name: 'userDetail', params: { id: row.Id } } : null
    },
  },
}
</script>
